module.exports = __webpack_public_path__ + "img/custom_card.fdb35075.jpg";